import "./Skeleton.css";

export default function Skeleton() {
  return (
    <div className="loading-skeleton">
      <div className="spinner"></div>
      <div className="text"></div>
    </div>
  );
}
